import { authConfig } from "../apiConfig";

// for get all completed worksite reports
export const get_worksite_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getWorksiteReport`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};